import { AgCellLocalStoreService, AgCellState } from '../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { isStringAnUrl } from '../../../../core/utilities';

interface DiffCellState extends AgCellState {}

@Injectable()
export class DiffCellLocalStoreService extends AgCellLocalStoreService<DiffCellState> {
  constructor() {
    super({
      cellValue: null, params: null
    });
  }

  readonly viewModel$ = this.state$.pipe(map(state => {
    return {
      ...state,
      isUrl: isStringAnUrl(state?.params?.value as string)
    }
  }))


}